import { post } from "../../../common/services/httpClient";
import type { ChangePasswordInputs } from "../types/managementTypes";

export const API_ENDPOINTS = {
  MANAGEMENT: {
    GET_USERS: "User/Search",
    GET_ROLES: "Role/Search",
    GET_ACTIONS: "Action/Get",
    SYNC_ACTIONS: "Actions/Sync",
    DELETE_ROLES: "Role/Delete",
    SAVE_ROLE: "Role/Save",
    GET_ROLE_BY_ID: "Role/GetById",
    UPDATE_ROLE: "Role/Update",
    GET_ROLE_ACTIONS: "Role/GetRoleActions",
    SAVE_ROLE_ACTIONS: "Role/SaveRoleActions",
    GET_USER_BY_ID: "User/GetById", 
    SAVE_USER: "User/Save",      
    UPDATE_USER: "User/Update", 
    ACTIVATE_DEACTIVATE_USER: "User/ActiveInActive",
    RESEND_ACTIVATION_EMAIL_USER: "User/ReSendActivationLink",
    CHANGE_PASSWORD: "User/ChangePassword",
    
    GET_MENUS: "Menu/Search",
    GET_MENUS_ID:"/Menu/GetById",
    GET_MENUS_SAVE:"/Menu/Save",
    GET_MENUS_UPDATE:"/Menu/Update",
    DELETE_MENU: "/Menu/Delete",

    GET_SUB_MENUS: "SubMenu/Search",
    GET_SUB_MENUS_ID: "/SubMenu/GetById",
    GET_SUB_MENUS_SAVE: "/SubMenu/Save",
    GET_SUB_MENUS_UPDATE: "/SubMenu/Update",
    DELETE_SUB_MENU: "/SubMenu/Delete"
    // Add other  endpoints here
  },
 
  // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
  MANAGEMENT: {
    USERS: ["GetUsers"],
    MENUS: ["GetMenus"],
    SUBMENUS: ["GetSubMenus"],
    ROLES: ["GetRoles"],
    ACTIONS: ["GetActions"],
    ROLE_ACTIONS: ["GetRoleActions"],
  },
  
};

export const changePassword = async (data: ChangePasswordInputs) => {
    const response = await post('/User/ChangePassword', data, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // or sessionStorage / cookie
        },
    });
    return response;
};
